<template>
  <v-container class="fill-height">
    <v-row no-gutters>
      <v-col cols="12" sm="6" :class="colClass">
        <LlistaActivitats :cursos="cursosdirigidos" :error="t('No_has_creado_ninguna_actividad')" :titol="titol_teves"
          :url="url" :mostrarAppend="true" :boto="boto" @open-dialog="openDialog" :isLoading="isLoadingDirigidos" />
      </v-col>
      <v-col cols="12" sm="6" class="pa-6">
        <!-- Capçalera i Introducció -->
        <v-row>
          <v-col cols="12">
            <h1>{{ t('Inspira') }}</h1>
            <p>{{ t('GineSIM_inspira_descripcion') }}</p>
          </v-col>
        </v-row>

        <!-- Secció de Participació Com a Docent -->
        <v-row>
          <v-col cols="12">
            <h2>{{ t('Participa_Como_Docente') }}</h2>
            <p>{{ t('Participa_Como_Docente_descripcion') }}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="6" :class="colClass">
        <LlistaActivitats :cursos="cursos" :error="t('No_eres_docente_de_ninguna_actividad')" :titol="titol" :url="url"
          :mostrarAppend="true" :isLoading="isLoadingCursos" />
        <v-col v-if="error" class="text-center">
          <p>{{ error }}</p>
          <v-btn class="ma-4" color="primary" :to="`/perfil`">
            {{ t('Accede_a_tu_perfil') }}
          </v-btn>
        </v-col>
      </v-col>
      <v-col cols="12" sm="6" :class="colClass">
        <v-skeleton-loader v-if="loading" :elevation="1" type="card"></v-skeleton-loader>
        <v-card v-for="ajuda in ajudes" :key="ajuda.id" :to="`/curso/${ajuda.id}`">
          <v-img height="200" cover :src="ajuda.imagen_url" class="align-end text-white"
            gradient="to top right, rgba(0,0,0,.7), rgba(0,0,0,.0)">
            <v-card-title>{{ ajuda.titulo }}</v-card-title>
          </v-img>
          <v-card-text>{{ ajuda.descripcion }}</v-card-text>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn color="primary" :to="`/curso/${ajuda.id}`" text>
              {{ t('Acceder') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>{{ t('Crear') }} {{ t('actividad') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="handleSubmit" prepend-icon="mdi-content-save">
            {{ t('Guardar') }}
          </v-btn>
          <v-btn icon @click="tancarDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel :title="t('Características_generales')">
                <v-expansion-panel-text>
                  <v-text-field v-model="cursoData.titulo" :label="t('Título')" :disabled="dialogType === 'delete'"
                    required />
                  <v-text-field v-model="cursoData.directorNombre" :label="t('Director')" readonly><template
                      v-slot:append>
                      <HelpComponent helpType="director"></HelpComponent>
                    </template></v-text-field>
                  <v-textarea v-model="cursoData.descripcion" :label="t('Descripción')"
                    :disabled="dialogType === 'delete'" required><template v-slot:append>
                      <HelpComponent helpType="descripcion"></HelpComponent>
                    </template></v-textarea>
                  <v-textarea v-model="cursoData.presentacion" :label="t('Presentación')"
                    :disabled="dialogType === 'delete'" required><template v-slot:append>
                      <HelpComponent helpType="presentacion"></HelpComponent>
                    </template></v-textarea>
                  <v-file-input v-model="cursoData.imagen" :label="t('Imagen')" prepend-inner-icon="mdi-camera"
                    accept="image/*" @change="handleFileUpload"><template v-slot:append>
                      <HelpComponent helpType="imagen"></HelpComponent>
                    </template></v-file-input>
                </v-expansion-panel-text>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-title>
                  <template #default>
                    <v-row no-gutters>
                      <v-col class="d-flex justify-start" cols="4">
                        {{ t('Acceso') }}
                      </v-col>
                      <v-col class="text-grey" cols="8">
                        {{ cursoData.estado_curso }}
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-autocomplete multiple v-model="cursoData.profesionales" :items="tiposProfesionales"
                    item-title="categoria" item-value="id" :label="t('Profesional')"><template v-slot:append>
                      <HelpComponent helpType="profesional"></HelpComponent>
                    </template></v-autocomplete>
                  <v-textarea v-model="emailsRaw"
                    label="Pega los emails de las personas a las que quieras conceder acceso (@vallhebron.cat)"
                    hint="Puedes copiar y pegar los emails seleccionandolos todos a la vez en una columna de Excel"
                    persistent-hint auto-grow :rows="3" />
                </v-expansion-panel-text>
              </v-expansion-panel>
              <v-expansion-panel :title="t('Características_avanzadas_opcionales')">
                <v-expansion-panel-text>
                  <v-select multiple v-model="cursoData.rama" :items="tiposRamas" item-title="categoria" item-value="id"
                    :label="t('Áreas')"  />
                  <v-text-field v-model="cursoData.fecha_inicio" :label="t('Fecha_de_inicio')" type="date" />
                  <v-text-field v-model="cursoData.fecha_fin" :label="t('Fecha_de_fin')" type="date" />
                  <v-text-field v-model="cursoData.experiencia_minima" :label="t('Experiencia mínima')" type="number" />
                  <v-text-field v-model="cursoData.experiencia_maxima" :label="t('Experiencia máxima')" type="number" />
                  <v-text-field v-model="cursoData.experiencia_docente" :label="t('Experiencia docente')"
                    type="number" />
                  <v-text-field v-model="cursoData.afos" label="AFOS"> <template v-slot:append>
                      <HelpComponent helpType="afos"></HelpComponent>
                    </template></v-text-field>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="handleSubmit" prepend-icon="mdi-content-save">
            {{ t('Guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpDialog" max-width="600px">
      <v-card>
        <v-card-title class="text-h5">{{ t('Ayuda') }}</v-card-title>
        <v-card-text>{{ helpText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="helpDialog = false">
            {{ t('Cerrar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { ref, reactive, watch, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user';
import { useUiStore   } from '@/stores/ui';
import { axios } from '../axios'
import { useDisplay } from 'vuetify';
import LlistaActivitats from './LlistaActivitats.vue'
import HelpComponent from './HelpComponent.vue'


const userStore = useUserStore();    // datos del usuario
const uiStore   = useUiStore();      // snackbar
const { t } = useI18n()
const display = useDisplay();

const cursos = ref([])
const ajudes = ref([])
const cursosdirigidos = ref([])

const isLoadingCursos = ref(true)
const isLoadingDirigidos = ref(true)

const tiposProfesionales = ref([])
const tiposRamas = ref([])

const error = ref('')

const titol_teves = ref(t('Tus_actividades_docentes'))
const titol = ref(t('Inspira_tus_alumnos'))
const url = '/curso/'
const boto = 'crea_activitat'

const dialog = ref(false)
const panel = ref([0, 1])

const snackbarText = ref('')
const emailsRaw = ref('')
const helpDialog = ref(false)
const loading = ref(true)
const helpText = ref('')

/**
 * Para habilitar o no campos, según sea "create", "delete", etc. 
 * (tu código lo tenía referenciado, pero no declarado, lo añadimos por coherencia)
 */
const dialogType = ref('create')

const cursoData = reactive({
  titulo: null,
  descripcion: null,
  directorNombre: '',
  fecha_inicio: null,
  fecha_fin: null,
  experiencia_minima: 0,
  experiencia_maxima: 0,
  experiencia_docente: 0,
  profesionales: [],
  rama: [1],
  imagen: null,
  estado_curso: 'privado',
  admitidos: [],
  afos: null,
  porcentaje_teorico: 50,
  puntaje_practico_diez: 10,
  presentacion: null,
})

// Retrieve userDetails from the store as a computed property
const userDetails = computed(() => userStore.userDetails);

const colClass = computed(() => {
  return display.smAndUp.value ? 'pa-6' : 'pa-0'
})

/**
 * WATCHERS
 */
watch(
  () => emailsRaw.value,
  (newVal) => {
    processPastedEmails(newVal)
  }
)

/**
 * METHODS (funciones)
 */

function processPastedEmails(emailsString) {
  const emails = emailsString.split(/\r?\n/)
  cursoData.admitidos = emails.map((email) => email.trim()).filter((email) => email)
}

async function fetchCursos() {
  try {
    const response = await axios.get(`inspira/`)
    cursos.value = response.data
    error.value = ''
  } catch (err) {
    console.error('Error al obtener los cursos:', err)
  }
  isLoadingCursos.value = false
}

async function fetchHelp() {
  loading.value = true
  try {
    const response = await axios.get(`help/`)
    ajudes.value = response.data
    error.value = ''
  } catch (err) {
    console.error('Error al obtener ajudes:', err)
  }
  loading.value = false
}

async function fetchCursosDirigidos() {
  try {
    const response = await axios.get(`cursos-dirigidos/`)
    cursosdirigidos.value = response.data
    error.value = ''
  } catch (err) {
    console.error('Error al obtener los cursos dirigidos:', err)
  }
  isLoadingDirigidos.value = false
}

async function fetchProfesionales() {
  try {
    const response = await axios.get(`profesionales/`)
    // Ordenamos por categoria
    tiposProfesionales.value = response.data.sort((a, b) => a.categoria.localeCompare(b.categoria))
  } catch (err) {
    console.error('Error obteniendo profesionales:', err)
  }
}

async function fetchRamas() {
  try {
    const response = await axios.get(`ramas/`)
    tiposRamas.value = response.data
  } catch (err) {
    console.error('Error obteniendo ramas:', err)
  }
}

function openDialog() {
  // Chequeo de usuario (ejemplo: debe ser de Vallhebron)
  if (userDetails.value.vallhebron) {
    cursoData.directorNombre = userDetails.value.first_name + ' ' + userDetails.value.last_name
    dialog.value = true
  } else {
    snackbarText.value = t('Sólo_pueden_crear_actividades_los_profesionales_de_Vallhebron')
    uiStore.triggerSnackbar( {
      message: snackbarText.value,
      color: 'info',
    })
  }
}

function tancarDialog() {
  dialog.value = false
}

function handleFileUpload(event) {
  if (event.target.files && event.target.files.length > 0) {
    cursoData.imagen = event.target.files[0]
  } else {
    cursoData.imagen = null
  }
}

async function handleSubmit() {
  if (cursoData.rama.length === 0) {
    snackbarText.value = t('Debes_seleccionar_al_menos_una_área_en_la_sección_de_visibilidad')
    uiStore.triggerSnackbar({
      message: snackbarText.value,
      color: 'error',
    })
    return
  }

  const formData = new FormData()
  Object.keys(cursoData).forEach((key) => {
    const value = cursoData[key]
    if (value !== null && value !== undefined) {
      if (key === 'imagen' && value instanceof File) {
        formData.append(key, value)
      } else if (key === 'admitidos' && Array.isArray(value)) {
        // Convertir el array a JSON (o lo que el backend requiera)
        formData.append(key, JSON.stringify(value))
      } else if (['profesionales', 'rama'].includes(key) && Array.isArray(value)) {
        // Para valores de array que se envían repetidos
        value.forEach((item) => {
          formData.append(key, item)
        })
      } else {
        formData.append(key, value)
      }
    }
  })

  try {
    const response = await axios.post('cursos/', formData)
    snackbarText.value = response.data.titulo + ' ' + t('fue_creado_con_éxito')
    uiStore.triggerSnackbar({
      message: snackbarText.value,
      color: 'success',
    })
    dialog.value = false
    // Refrescar
    fetchCursos()
    fetchCursosDirigidos()
  } catch (err) {
    if (err.response) {
      if (err.response.data.non_field_errors) {
        snackbarText.value = 'Error: ' + err.response.data.non_field_errors.join(', ')
      } else if (err.response.data.detail) {
        snackbarText.value = 'Error: ' + err.response.data.detail
      } else {
        // Manejar errores específicos por campo
        snackbarText.value = ''
        Object.keys(err.response.data).forEach((key) => {
          snackbarText.value += `${key}: ${err.response.data[key].join(', ')}; `
        })
      }
    }
    uiStore.triggerSnackbar({
      message: snackbarText.value,
      color: 'error',
    })
  }
}

/**
 * LIFECYCLE
 */
onMounted(() => {
  fetchHelp()
  fetchProfesionales()
  fetchRamas()
  fetchCursos()
  fetchCursosDirigidos()
})
</script>